var global = require('./_global');
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';



//////////////////
// WEBPACK FOOTER
// /Users/cully/projects/Jobs/abound/~/core-js/modules/_user-agent.js
// module id = ../../node_modules/core-js/modules/_user-agent.js
// module chunks = 18